
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("faPQm", function(module, exports) {
parcelRequire("lRSO6");
parcelRequire("8oLfs");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $jsLXn = parcelRequire("jsLXn");

var $9F6Ii = parcelRequire("9F6Ii");

var $fSv0p = parcelRequire("fSv0p");
const $69d0f3abd60f4ca9$var$renderUpflow = (domId, touchpointId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholder = document.getElementById(domId);
    if (!placeholder) throw new Error('placeholder was not found whilst trying to create the upflow-app.');
    (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fSv0p.UpFlowApp), {
        touchpointId: touchpointId
    }))), placeholder);
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.JIRA_UPFLOW = {
    // @ts-expect-error - TS7006 - Parameter 'domId' implicitly has an 'any' type. | TS7006 - Parameter 'touchpointId' implicitly has an 'any' type.
    render: (domId, touchpointId)=>$69d0f3abd60f4ca9$var$renderUpflow(domId, touchpointId)
};

});
parcelRegister("jsLXn", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $88b19a22a09480ac$export$6f7845cc5e693f16);

var $5uXOq = parcelRequire("5uXOq");

var $irJ4w = parcelRequire("irJ4w");

var $lzeFL = parcelRequire("lzeFL");

var $5tsrJ = parcelRequire("5tsrJ");

var $1OjhZ = parcelRequire("1OjhZ");

var $j8DrX = parcelRequire("j8DrX");

var $1nUas = parcelRequire("1nUas");

var $2HbP2 = parcelRequire("2HbP2");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $a83ud = parcelRequire("a83ud");
const $88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, children);

const $88b19a22a09480ac$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hWnRN"))
    };
    const { data: orgId } = (0, $14XJw.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
            messages: state.messages,
            locale: (0, $lzeFL.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irJ4w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a83ud.LoadingPhaseManager), null));
};

});
parcelRegister("1OjhZ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $5cef917adb45d092$export$6f49c95a810d59fa);

var $5uXOq = parcelRequire("5uXOq");

var $ha42n = parcelRequire("ha42n");
var $bSOOm = parcelRequire("bSOOm");

var $9sAyK = parcelRequire("9sAyK");
const $5cef917adb45d092$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
        callback
    ]);
const $5cef917adb45d092$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $5uXOq.useState)(new (0, $ha42n.ExperienceTracker)());
    const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, $9sAyK.sliSubscriber)));
    const cleanup = (0, $5uXOq.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $5cef917adb45d092$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSOOm.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("ha42n", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $19380a56c83c3ed5$export$12b6b072930fd68f);

var $82vfp = parcelRequire("82vfp");
class $19380a56c83c3ed5$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $82vfp.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("82vfp", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $abf5733617623630$export$c90b54e658fc4d7c);

var $j0xjM = parcelRequire("j0xjM");
function $abf5733617623630$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $abf5733617623630$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $j0xjM.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("j0xjM", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $f8ffb4638fa466dd$export$d27a2b6293f7631c);
class $f8ffb4638fa466dd$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("9sAyK", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $6b2f2360dd11edee$export$db0b99fe17114899);

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

const $6b2f2360dd11edee$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $6b2f2360dd11edee$var$transformApplication(application),
            edition: $6b2f2360dd11edee$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("1nUas", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $0264700d4de7e638$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});

parcelRegister("2HbP2", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $d012230882eb31a4$export$7c9538f5f3c365e9);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $4R6GH = parcelRequire("4R6GH");

var $gJdig = parcelRequire("gJdig");
const $d012230882eb31a4$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $5uXOq.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $5uXOq.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJdig.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, modals.map((modal)=>{
        return (0, $4R6GH.fg)('jpo-31059_modal_close_behaviour_controls') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d012230882eb31a4$var$RenderModal, {
            key: modal.key,
            modal: modal
        }) : // @ts-expect-error - TS2739 - Complaining about lack of the new props, will be deleted on jpo-31059_modal_close_behaviour_controls cleanup
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(modal.component, {
            key: modal.key,
            onClose: modal.close
        });
    })));
}

});
parcelRegister("gJdig", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $308ba6e6ba886f08$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $308ba6e6ba886f08$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("8ApFP", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $a83c9e8eeb3d40c2$export$c71778b3a4356b04);

var $cfDZ3 = parcelRequire("cfDZ3");

var $hVf1M = parcelRequire("hVf1M");
const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $cfDZ3.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $cfDZ3.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $cfDZ3.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $hVf1M.getIsProjectAdmin)
    }
});

});
parcelRegister("hVf1M", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $d8c128d9b214e073$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $d8c128d9b214e073$export$d53e6d79d3fa5f31);
let $d8c128d9b214e073$var$projectAdmin = null;
const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
};
const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $d8c128d9b214e073$var$projectAdmin = projectAdminState;
};

});


parcelRegister("fiv1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dee5a929ec50c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $41dee5a929ec50c3$export$83fb48644dee72f0);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");
function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
        environment: (0, $5yJb9.default)()
    }, children);
}
function $41dee5a929ec50c3$export$83fb48644dee72f0() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("5yJb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $eiowN = parcelRequire("eiowN");

var $aWXMn = parcelRequire("aWXMn");
let $0dfb67cb8d2ba29a$var$relayEnvironment;
function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
    if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
        const environmentConfig = (0, $aWXMn.getRelayEnvironmentConfig)();
        $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
    }
    return $0dfb67cb8d2ba29a$var$relayEnvironment;
}

});
parcelRegister("aWXMn", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $eb7981c11bea2531$export$a451c85db2d1cda3);

var $4XQuR = parcelRequire("4XQuR");

var $d89yU = parcelRequire("d89yU");

var $6LmWt = parcelRequire("6LmWt");
const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, $6LmWt.getDefaultRelayEnvironmentConfig)({
        network: (0, $d89yU.getNetwork)(),
        log: (0, $4XQuR.default),
        requiredFieldLogger: $4XQuR.requiredFieldLogger
    });

});
parcelRegister("4XQuR", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $50b0aa0805b37d6d$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $50b0aa0805b37d6d$export$2e2bcd8739ae039);

var $bFU4G = parcelRequire("bFU4G");

var $2YZCu = parcelRequire("2YZCu");

var $jp5kW = parcelRequire("jp5kW");
const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
const $50b0aa0805b37d6d$var$requests = {};
const $50b0aa0805b37d6d$var$queries = {};
const $50b0aa0805b37d6d$var$resources = {};
const $50b0aa0805b37d6d$var$executes = {};
const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
    if ((0, $jp5kW.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                    $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                        delete $50b0aa0805b37d6d$var$queries[name];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $50b0aa0805b37d6d$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $bFU4G.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $50b0aa0805b37d6d$var$queries[node.name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $50b0aa0805b37d6d$var$executes[event.executeId] = {
                name: event.params.name,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"query" | "mutation" | "subscription"'.
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next':
            $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
            break;
        case 'execute.async.module':
            break;
        case 'execute.flight.payload_deserialize':
            break;
        case 'execute.error':
            delete $50b0aa0805b37d6d$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $50b0aa0805b37d6d$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("d89yU", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $7997274d03790a98$export$7de4970ebfd8206d);

var $eiowN = parcelRequire("eiowN");

var $gIJXH = parcelRequire("gIJXH");

var $k1TrK = parcelRequire("k1TrK");

var $fwvto = parcelRequire("fwvto");
const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
    if ((0, $fwvto.isSSR)()) (0, $eiowN.Network).create((0, $gIJXH.fetch));
    return (0, $eiowN.Network).create((0, $gIJXH.fetch), (0, $k1TrK.subscribe));
};

});
parcelRegister("gIJXH", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);

var $4R6GH = parcelRequire("4R6GH");

var $9XhfI = parcelRequire("9XhfI");

var $dMryf = parcelRequire("dMryf");
const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    return (0, $4R6GH.fg)('jfp-magma-support-defer') ? (0, $9XhfI.fetch)(request, variables, cacheConfig) : (0, $dMryf.fetch)(request, variables, cacheConfig);
};

});
parcelRegister("9XhfI", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $4pgHP = parcelRequire("4pgHP");

var $eCZ6m = parcelRequire("eCZ6m");

var $5Wobd = parcelRequire("5Wobd");

var $jlPGx = parcelRequire("jlPGx");

var $ifOJ4 = parcelRequire("ifOJ4");

var $jCRE8 = parcelRequire("jCRE8");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
const $1ea431952d5687e8$var$getQueryResponseCache = ()=>(0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? (0, $7pVV3.getQueryResponseCache)() : (0, $7pVV3.QueryResponseCache);
// @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
const $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $1ea431952d5687e8$var$moduleID = 'relay-fetch';
const $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    const redirecting = (0, $aLyyN.checkAuthentication)();
    if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $eiowN.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        if ((0, $4R6GH.fg)('obsrve-2487-gql-use-traceid-extensions-field')) (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
        else (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getRequestIdFromExtensions)(response));
        (0, $4pgHP.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $5a0Nh.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $5a0Nh.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$1ea431952d5687e8$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                if ('incremental' in response && response.incremental?.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                // the pending versus completed values, so we can just return the array without the extra account keeping.
                // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                // TypeScript can't handle the polymorphism.
                sink.next(response.incremental);
                else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                sink.next(response);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = $1ea431952d5687e8$var$getQueryResponseCache().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                    $1ea431952d5687e8$var$getQueryResponseCache().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) // TODO MAGMA-3017: force close if server timeout or DomContentLoaded
                    // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                    // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                    // Receive response events as they are streamed from the server.
                    (0, $ifOJ4.getClientDispatcher)().register(sinkID, handleResponse);
                    else finalise();
                    return;
                }
            }
            const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
            const body = (0, $eCZ6m.getRequestBody)(request, variables);
            const fetchOverNetwork = (0, $jCRE8.buildGraphqlFetch)(endpoint, (0, $aLyyN.generateOptions)({
                body: body
            }, endpoint));
            const initialSource = ()=>!false && earlyScriptPromise ? (0, $jCRE8.withErrorHandling)(earlyScriptPromise) : (0, $jCRE8.withErrorHandling)(fetchOverNetwork());
            const responses = (0, $jCRE8.processMultipartPromise)(()=>(0, $6b2ko.retryOnError)(initialSource, {
                    retryFunc: ()=>(0, $jCRE8.withErrorHandling)(fetchOverNetwork()),
                    retryPredicate: (0, $aLyyN.shouldRetry),
                    retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                }));
            // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
            // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
            let responseShouldHang = false;
            let firstResponseUsed = false;
            let resolveFirstResponse;
            const firstResponse = new Promise((resolve)=>{
                resolveFirstResponse = resolve;
            });
            responses.subscribe({
                start: ()=>{
                    if (requestID != null) {
                        (0, $kipqU.QueryPromisesMap).set(requestID, firstResponse);
                        (0, $kipqU.CompletedQueryPromisesMap).set(requestID, completedResponse);
                    }
                },
                next: (response)=>{
                    if (false && $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                        // Send the response payload to a side-channel.
                        // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                        (0, $jlPGx.registerEvent)({
                            id: sinkID,
                            name: 'default',
                            args: [
                                response
                            ]
                        });
                        // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                        return;
                    }
                    if (!firstResponseUsed) {
                        firstResponseUsed = true;
                        // according to spec, we can assume the first response is a GraphQLSingularResponse.
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const singularResponse = response;
                        augmentResponse(singularResponse);
                        if (!validateResponse(singularResponse)) {
                            //  Short circuit operation and handle the unauthorized errors.
                            (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                            responseShouldHang = true;
                            return;
                        }
                        enforceNonNullability(singularResponse);
                        // write cache query response on SSR
                        if (false && requestID != null) $1ea431952d5687e8$var$getQueryResponseCache().setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                    }
                    handleResponse(response);
                    // signal that the initial response has been received
                    // so that SSR SPA knows it is safe to render
                    resolveFirstResponse();
                    // After the initial response, further responses are sent through a side-channel.
                    if (false && $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled()) finalise();
                },
                error: (error)=>{
                    if (!firstResponseUsed) firstResponseUsed = true;
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                },
                complete: ()=>{
                    if (responseShouldHang) return;
                    finalise();
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("6b2ko", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $6910b563ec955346$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $6910b563ec955346$export$f859c88bfac2cf2c);
const $6910b563ec955346$export$81189edc9b923717 = 1;
const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("5a0Nh", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $cf86a52470c84b66$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $cf86a52470c84b66$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $cf86a52470c84b66$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $cf86a52470c84b66$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $7Jxgt = parcelRequire("7Jxgt");
const $cf86a52470c84b66$var$errorCollector = new Map();
const $cf86a52470c84b66$export$da396ad2a542b095 = 120000; // 2min
const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $cf86a52470c84b66$var$errorCollector.delete(key);
    }, $cf86a52470c84b66$export$da396ad2a542b095);
};
const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, $7Jxgt.v4)())=>{
    $cf86a52470c84b66$var$errorCollector.set(key, []);
    $cf86a52470c84b66$var$scheduleCleanup(key);
    return key;
};
const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
    const errors = $cf86a52470c84b66$var$errorCollector.get(key);
    $cf86a52470c84b66$var$errorCollector.delete(key);
    return errors || [];
};
const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
        $cf86a52470c84b66$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("kipqU", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $f428f7f15822f637$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $f428f7f15822f637$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();
const $f428f7f15822f637$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("7pVV3", function(module, exports) {

$parcel$export(module.exports, "QueryResponseCache", () => $675c7f0a9d659efe$export$688bd21be71b9e5d);
$parcel$export(module.exports, "getQueryResponseCache", () => $675c7f0a9d659efe$export$3233e692a93c0cfd);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $eiowN = parcelRequire("eiowN");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $4R6GH = parcelRequire("4R6GH");

var $kizcd = parcelRequire("kizcd");
function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $eiowN.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $675c7f0a9d659efe$export$da2711d74cd28aed = [
    'fetchModulesV2Query'
];
class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$675c7f0a9d659efe$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $kizcd.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $2YZCu.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $675c7f0a9d659efe$export$3233e692a93c0cfd = (0, $8QpSo.default)(()=>new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    }));
const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>((0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? $675c7f0a9d659efe$export$3233e692a93c0cfd() : $675c7f0a9d659efe$export$688bd21be71b9e5d).serialize();

});
parcelRegister("kizcd", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $f174935352f053b0$export$8431e42d062de453);
class $f174935352f053b0$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("ajjqZ", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $383b599fde987e1e$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $383b599fde987e1e$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $383b599fde987e1e$export$e1336d32be02faf4);
$parcel$export(module.exports, "earlyFetch", () => $383b599fde987e1e$export$5b55058781674413);

var $tcn7E = parcelRequire("tcn7E");

var $l83Uu = parcelRequire("l83Uu");

var $eKonk = parcelRequire("eKonk");

var $eCZ6m = parcelRequire("eCZ6m");
const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
    const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
    if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
    return result;
};
const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
};
const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $l83Uu.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $eCZ6m.getAggEndpoint)(compiledQuery.params);
    const body = (0, $eCZ6m.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability ?? null);
    $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(endpoint),
            ...capabilityHeader ? {
                [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $l83Uu.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("l83Uu", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $ef655a7b07a35675$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $ef655a7b07a35675$export$e88cb5bfb57ce9c4);

var $dO0aE = parcelRequire("dO0aE");
const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);

});
parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});



parcelRegister("jlPGx", function(module, exports) {

$parcel$export(module.exports, "registerEvent", () => $8c8d2c511a52b5a9$export$bd50bc4cd3c601ee);
const $8c8d2c511a52b5a9$var$events = [];
const $8c8d2c511a52b5a9$export$bd50bc4cd3c601ee = (event)=>{
    $8c8d2c511a52b5a9$var$events.push(event);
};
/**
 * Take all events registered so far, return them, and clear the list.
 */ const $8c8d2c511a52b5a9$export$3c7145db84d4587c = ()=>{
    return $8c8d2c511a52b5a9$var$events.splice(0, $8c8d2c511a52b5a9$var$events.length);
};

});

parcelRegister("ifOJ4", function(module, exports) {

$parcel$export(module.exports, "getClientDispatcher", () => $c402b43f217e880b$export$5bb012cf9b3a5452);
let $c402b43f217e880b$var$dispatcher;
/**
 * The glue between a {@link ServerToClientEvent} and a client-side component.
 *
 * This class is responsible for ingesting events from the server and dispatching them to the correct component.
 *
 * Components hoping to be called from the server must be registered. Today, that's a manual call a developer
 * needs to make. Tomorrow, that may be automatically generated by the compiler reading a code annotation.
 */ class $c402b43f217e880b$var$ClientDispatcher {
    #handlers;
    #queuedPayloads;
    constructor(){
        this.#handlers = new Map();
        this.#queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.#handlers.get(payload.id);
        if (handler) this.#exec(handler, payload);
        else {
            const queue = this.#queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.#queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.#handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.#queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.#exec(callback, payload));
            this.#queuedPayloads.delete(id);
        }
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ #exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}
const $c402b43f217e880b$export$5bb012cf9b3a5452 = ()=>{
    if (!$c402b43f217e880b$var$dispatcher) $c402b43f217e880b$var$dispatcher = new $c402b43f217e880b$var$ClientDispatcher();
    return $c402b43f217e880b$var$dispatcher;
};

});

parcelRegister("jCRE8", function(module, exports) {

$parcel$export(module.exports, "processMultipartPromise", () => $263b59cc260a85be$export$f76505a7f2969e4e);
$parcel$export(module.exports, "withErrorHandling", () => $263b59cc260a85be$export$c874c20f7c9f97c);
$parcel$export(module.exports, "buildGraphqlFetch", () => $263b59cc260a85be$export$744180da2870332e);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $eiowN = parcelRequire("eiowN");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $5HnTq = parcelRequire("5HnTq");


var $eusud = parcelRequire("eusud");
function $263b59cc260a85be$var$getBoundary(contentType) {
    const boundaryMatch = contentType.match(/boundary=['"]([^;]+)['"]/);
    return boundaryMatch ? boundaryMatch[1] : null;
}
/**
 * Processes a chunk of multipart data and emits parsed JSON payloads to the observer
 * Uses a more memory-efficient approach by processing chunks directly
 */ function $263b59cc260a85be$var$processChunk(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [, body] = part.split(/\r?\n\r?\n/);
            if (body) try {
                const jsonData = JSON.parse(body.trim());
                observer.next(jsonData);
            } catch (error) {
                observer.error(new Error(`Invalid JSON: ${error instanceof Error ? error.message : String(error)}`));
            }
        }
    }
    // Return the last part which might be incomplete
    return parts[parts.length - 1];
}
/**
 * Processes a ReadableStream of multipart data with improved memory efficiency
 */ async function $263b59cc260a85be$var$processStream(reader, boundary, observer) {
    const decoder = new TextDecoder('utf-8');
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    const processNextChunk = async ()=>{
        const result = await reader.read();
        if (result.done) {
            // Process any remaining data
            if (incompleteChunk.length > 0) $263b59cc260a85be$var$processChunk(incompleteChunk, boundaryString, observer);
            observer.complete();
            return;
        }
        // Decode the new chunk and combine with any incomplete data from previous chunk
        const newText = decoder.decode(result.value, {
            stream: true
        });
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $263b59cc260a85be$var$processChunk(combinedChunk, boundaryString, observer);
        return processNextChunk();
    };
    await processNextChunk();
}
function $263b59cc260a85be$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $263b59cc260a85be$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const reader = response.body?.getReader();
    if (!reader) {
        observer.error(new Error('Failed to get reader from response body'));
        return;
    }
    $263b59cc260a85be$var$processStream(reader, boundary, observer).catch((error)=>observer.error(error));
}
function $263b59cc260a85be$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $263b59cc260a85be$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>observer.error(error));
}
function $263b59cc260a85be$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $eiowN.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $263b59cc260a85be$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $263b59cc260a85be$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $263b59cc260a85be$var$handleMultipartResponse(response, observer);
            else observer.error(new Error(`Unsupported content type: ${contentType}`));
        }).catch((error)=>observer.error(error));
    });
}
function $263b59cc260a85be$export$c874c20f7c9f97c(source) {
    return source.then((0, $eusud.handleErrors)).catch((0, $eusud.handleNetworkErrors));
}
function $263b59cc260a85be$export$744180da2870332e(url, options) {
    const acceptableFormats = [
        'application/graphql-response+json',
        'application/json'
    ];
    // Accept multipart responses on the client, or only on servers that explicitly support receiving and then handing over incremental responses.
    // @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
    if (!(false && !globalThis.__SSR_HANDOVER_INCREMENTS)) acceptableFormats.push('multipart/mixed');
    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: acceptableFormats.join(', ')
        }
    };
    return ()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            ...options,
            ...postOptions
        }));
}
function $263b59cc260a85be$export$2586da7b5f4b5763(url, options) {
    const fetchFn = $263b59cc260a85be$export$744180da2870332e(url, options);
    return $263b59cc260a85be$export$f76505a7f2969e4e(()=>$263b59cc260a85be$export$c874c20f7c9f97c(fetchFn()));
}

});
parcelRegister("8KpGl", function(module, exports) {

$parcel$export(module.exports, "getReroutableURL", () => $e8054b634989671a$export$23769875e8eebaf6);

var $g96Vw = parcelRequire("g96Vw");
// FIXME: Pillar to define entire URL, not just hostname.
const $e8054b634989671a$var$LOCAL_URL = new URL(`${'http'}://${(0, $g96Vw.getDevHostname)()}:${(0, $g96Vw.getProxyServerPort)()}`);
function $e8054b634989671a$export$23769875e8eebaf6(pathOrURL) {
    var e;
    return pathOrURL;
}

});
parcelRegister("g96Vw", function(module, exports) {

$parcel$export(module.exports, "getDevHostname", () => $e257580e5f260c28$export$a6aba27c4797e08b);
$parcel$export(module.exports, "getProxyServerPort", () => $e257580e5f260c28$export$6819122a922c6aaf);
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ const $e257580e5f260c28$export$a6aba27c4797e08b = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
function $e257580e5f260c28$export$6819122a922c6aaf() {
    return 9000;
}

});


const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("eusud", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $3637c0f7edbd2bb4$export$8e9baed7697e4959);
$parcel$export(module.exports, "handleNetworkErrors", () => $3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
$parcel$export(module.exports, "handleErrors", () => $3637c0f7edbd2bb4$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "applyErrorHandling", () => $3637c0f7edbd2bb4$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $3637c0f7edbd2bb4$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $3637c0f7edbd2bb4$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $3637c0f7edbd2bb4$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $3637c0f7edbd2bb4$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $3637c0f7edbd2bb4$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $3637c0f7edbd2bb4$export$a5717cbee13f28b7);


var $jp5kW = parcelRequire("jp5kW");

var $5HnTq = parcelRequire("5HnTq");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $6b2ko = parcelRequire("6b2ko");

var $iwPwz = parcelRequire("iwPwz");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $jJZqs.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $3637c0f7edbd2bb4$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $3637c0f7edbd2bb4$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $3637c0f7edbd2bb4$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $3637c0f7edbd2bb4$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
const $3637c0f7edbd2bb4$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $3637c0f7edbd2bb4$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $iwPwz.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $jp5kW.default)('platform_fetch_retries')) return executeRequest();
    return (0, $6b2ko.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    });
const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    });

});
parcelRegister("iwPwz", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $19a21974d2ff6598$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $19a21974d2ff6598$export$b569b31eebca952d);

var $fnyT4 = parcelRequire("fnyT4");
const $19a21974d2ff6598$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $19a21974d2ff6598$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("fnyT4", function(module, exports) {

$parcel$export(module.exports, "TRACE_ID_HEADER", () => $5d3410503b671c4b$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $5d3410503b671c4b$export$830a89e935012abe);
const $5d3410503b671c4b$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $5d3410503b671c4b$export$830a89e935012abe = [
    $5d3410503b671c4b$export$4b69438fb7c7b9b2,
    $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS
];

});




parcelRegister("lKFKm", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $42cb6e1c2fdc593e$export$758fcc357484571e);

var $pa9q9 = parcelRequire("pa9q9");

var $fjcgS = parcelRequire("fjcgS");

var $8iiwm = parcelRequire("8iiwm");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
    (0, $pa9q9.showFlag)({
        type: 'error',
        title: (0, $8iiwm.default).title,
        description: (0, $8iiwm.default).description,
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $8iiwm.default).login,
                onClick: $42cb6e1c2fdc593e$var$reloadPage
            }
        ]
    });
    $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("pa9q9", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $00ff685527f9e8c1$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $00ff685527f9e8c1$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $00ff685527f9e8c1$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $00ff685527f9e8c1$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $00ff685527f9e8c1$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $00ff685527f9e8c1$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $00ff685527f9e8c1$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $00ff685527f9e8c1$export$c126d8b307b8ab86);

var $fHfPB = parcelRequire("fHfPB");

var $gEdnQ = parcelRequire("gEdnQ");

var $01A9Z = parcelRequire("01A9Z");

var $7HGHK = parcelRequire("7HGHK");
const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, $gEdnQ.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, $fHfPB.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
    $00ff685527f9e8c1$export$900a08a292ad23cd((0, $fHfPB.dismissFlag)(id));
};
const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, $01A9Z.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
    showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
    dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
};
const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
        hasFlag: $00ff685527f9e8c1$var$hasFlag
    });
const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $7HGHK.DISMISS_COMMAND);
const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("fHfPB", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $8eb241d1a1f5d9b7$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $8eb241d1a1f5d9b7$export$2e2bcd8739ae039);

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $7HGHK.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $d6YjM.dismissFlagAction)(action.id));
    };

});
parcelRegister("d6YjM", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $07f19e2fef34903b$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $07f19e2fef34903b$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $07f19e2fef34903b$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $07f19e2fef34903b$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $07f19e2fef34903b$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $07f19e2fef34903b$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $07f19e2fef34903b$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $07f19e2fef34903b$export$aad8462122ac592b);
const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
        type: $07f19e2fef34903b$export$9d04158a25ce4cd,
        payload: payload
    });
const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
        type: $07f19e2fef34903b$export$b31a07d2e6382678,
        payload: payload
    });
const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
        type: $07f19e2fef34903b$export$1eb56620df104bf,
        payload: payload
    });
const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
        type: $07f19e2fef34903b$export$4a991c87e640ef77
    });

});

parcelRegister("7HGHK", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $9deb2cdefe93babb$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $9deb2cdefe93babb$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $9deb2cdefe93babb$export$188cdb77b72629d7);
const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("gEdnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c019df33694ffbe1$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $d6YjM.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $d6YjM.show)(newFlag));
        return flagId;
    };

});

parcelRegister("01A9Z", function(module, exports) {

$parcel$export(module.exports, "store", () => $5787309a6ab0ba9c$export$6f57813fe9f31bf9);

var $imvpl = parcelRequire("imvpl");
const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, $imvpl.createStore)();

});
parcelRegister("imvpl", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6bbcd4b408b9a94e$export$f51a9068ac82ea43);

var $F2Mxm = parcelRequire("F2Mxm");

var $gG398 = parcelRequire("gG398");
const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'flags',
        rootReducer: $gG398.default,
        rootEpic: rootEpic
    });

});
parcelRegister("F2Mxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca77440264e922e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $i9gPl = parcelRequire("i9gPl");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i9gPl.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, $hkadP.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("iGv2H", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $a4079cece44c0fab$export$342c99cc1e9bc5c6);
const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("hkadP", function(module, exports) {

$parcel$export(module.exports, "default", () => $607c98afd3082218$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $3f2cs.compose;
};

});

parcelRegister("i9gPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $330df53c22ed8aaf$export$2e2bcd8739ae039);
class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("gG398", function(module, exports) {

$parcel$export(module.exports, "default", () => $1feeabef4760da78$export$2e2bcd8739ae039);

var $ifg6x = parcelRequire("ifg6x");

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");
const $1feeabef4760da78$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
    switch(action.type){
        case 0, $d6YjM.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))([
                    {
                        id: (0, $7Jxgt.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $d6YjM.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $d6YjM.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $d6YjM.RESET:
            return $1feeabef4760da78$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("8iiwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ec0f26423b786$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("7isEg", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $6c554999a424d172$export$726e1df8186bb981);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");
const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: (error)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null)
            });
        },
        logErrorRetry: (error, retryAttempt)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null),
                retryAttempt: retryAttempt
            });
        }
    };
};

});

parcelRegister("aLyyN", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $00bea5ba58fba29b$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $00bea5ba58fba29b$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $00bea5ba58fba29b$export$9dec0f42cc67f6ab);
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $00bea5ba58fba29b$export$eefb7f54c3b07211);
$parcel$export(module.exports, "getRequestIdFromExtensions", () => $00bea5ba58fba29b$export$751e3e5dc81a08d0);
$parcel$export(module.exports, "generateOptions", () => $00bea5ba58fba29b$export$c21133b4499f5374);
$parcel$export(module.exports, "shouldRetry", () => $00bea5ba58fba29b$export$7bfea3c3d460ecd8);

var $hGgHi = parcelRequire("hGgHi");

var $1UikQ = parcelRequire("1UikQ");

var $kTK0a = parcelRequire("kTK0a");

var $2I8bw = parcelRequire("2I8bw");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $6b2ko = parcelRequire("6b2ko");

var $4tcSU = parcelRequire("4tcSU");

var $gwtGO = parcelRequire("gwtGO");
let $00bea5ba58fba29b$var$redirecting = false;
const $00bea5ba58fba29b$var$redirect = ()=>{
    const identity = (0, $kTK0a.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $00bea5ba58fba29b$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$00bea5ba58fba29b$var$redirecting) {
        const heartbeatService = (0, $2I8bw.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            $00bea5ba58fba29b$var$redirect();
            // Set flag to prevent multiple redirects
            $00bea5ba58fba29b$var$redirecting = true;
        }
    }
    return $00bea5ba58fba29b$var$redirecting;
};
const $00bea5ba58fba29b$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $00bea5ba58fba29b$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $6b2ko.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $00bea5ba58fba29b$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $00bea5ba58fba29b$export$751e3e5dc81a08d0 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.request_id;
    return undefined;
};
const $00bea5ba58fba29b$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $4tcSU.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $5HnTq.getDefaultOptions)((0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? url : null),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(','),
            ...csrfTokenHeader
        }
    });
};
const $00bea5ba58fba29b$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $jJZqs.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("gwtGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1019e315ad42f34a$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});



parcelRegister("dMryf", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $4pgHP = parcelRequire("4pgHP");

var $eCZ6m = parcelRequire("eCZ6m");

var $5Wobd = parcelRequire("5Wobd");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
const $cad88c39422b51e7$var$getQueryResponseCache = ()=>(0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? (0, $7pVV3.getQueryResponseCache)() : (0, $7pVV3.QueryResponseCache);
const $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    const redirecting = (0, $aLyyN.checkAuthentication)();
    if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $eiowN.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
            const body = (0, $eCZ6m.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = $cad88c39422b51e7$var$getQueryResponseCache().get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) $cad88c39422b51e7$var$getQueryResponseCache().delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $6b2ko.retryOnError)(()=>(0, $eusud.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $eusud.performPostRequest)(endpoint, (0, $aLyyN.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $eusud.performPostRequestWithRetry)(endpoint, {
                ...(0, $aLyyN.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                if ((0, $4R6GH.fg)('obsrve-2487-gql-use-traceid-extensions-field')) (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
                else (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getRequestIdFromExtensions)(response));
                (0, $4pgHP.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $5a0Nh.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $5a0Nh.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                        // Surprise behaviour: the observable should hang indefinitely here!
                        // At least, that is the expectation of existing code; see src/packages/issue/issue-view/src/integration-tests/experience-tracking/view.cy-integration.tsx
                        // Which assumes that the operation never completes, so relay never receives a (null) response, so it never complains about the data.
                        // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) $cad88c39422b51e7$var$getQueryResponseCache().setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) // todo: stop sending the value of the promise to QueryPromisesMap. Might happen as part of cleaning up the feature gate for defer support writ large.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $kipqU.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});


parcelRegister("k1TrK", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $4ced6779db298dc0$export$ec068583843480e7);

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $lWhTC = parcelRequire("lWhTC");

var $1Uhm6 = parcelRequire("1Uhm6");

var $cfDZ3 = parcelRequire("cfDZ3");
const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
        const client = (0, $lWhTC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $1Uhm6.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $cfDZ3.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("lWhTC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $2a46eca1e9133707$export$6bb76d6eba7e258c);

var $4U1PW = parcelRequire("4U1PW");

var $jp5kW = parcelRequire("jp5kW");

var $gwtGO = parcelRequire("gwtGO");


var $hoQbP = parcelRequire("hoQbP");
let $2a46eca1e9133707$var$client;
const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
    if ((0, $hoQbP.isSSR)() || (0, $jp5kW.default)('graphql_subscriptions')) return null;
    if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, $4U1PW.createClient)({
        url: (0, $hoQbP.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
        retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(',')
        }
    });
    return $2a46eca1e9133707$var$client;
};
const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
    $2a46eca1e9133707$var$client = null;
};

});
const $37d1b046897e548f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("hoQbP", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $9e6d9986231c3fe5$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $9e6d9986231c3fe5$export$29a72e89601dfc59);
const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("1Uhm6", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $db2d4e9951ebaa0f$export$ece4736473c28965);
const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`ErrorEvent: "${error.error}"`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});


parcelRegister("fwvto", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $c5bf640417859136$export$48d7c418edadb60c);
const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("a83ud", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $j7rCb = parcelRequire("j7rCb");
const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $j7rCb.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hWnRN", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("9F6Ii", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $02febe252cc7980c$export$5f8d39834fd61797);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $02febe252cc7980c$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $4R6GH.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).StrictMode, null, children);
};

});

parcelRegister("fSv0p", function(module, exports) {

$parcel$export(module.exports, "UpFlowApp", () => $cd234d63206366c5$export$35dcbd249d6408d0);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $43vGl = parcelRequire("43vGl");
const $cd234d63206366c5$export$35dcbd249d6408d0 = ({ touchpointId: touchpointId })=>{
    const props = {
        touchpointId: touchpointId,
        isOpen: true,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onUpFlowDismiss: ()=>{}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $43vGl.DialogContent), props));
};

});
parcelRegister("43vGl", function(module, exports) {

$parcel$export(module.exports, "DialogContent", () => $c53bf002280dbd18$export$b6d9565de1e068cf);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


var $4jqJv = parcelRequire("4jqJv");

var $g1xDo = parcelRequire("g1xDo");

const $c53bf002280dbd18$var$DialogContentLazy = (0, $az4zD.injectIntlV2)((0, $34Vv8.default)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazy)(()=>(parcelRequire("4fVfu")).then(({ DialogContent: DialogContent })=>DialogContent), {
    moduleId: "./src/packages/growth/up-flow/up-flow-touchpoint/src/ui/dialog-content/main.tsx"
})));
const $c53bf002280dbd18$export$b6d9565de1e068cf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $e6fca9f53887b39e$export$dc83269c840e42),
        packageName: (0, $e6fca9f53887b39e$export$dc83269c840e42),
        teamName: "luna-growth",
        fallback: "flag",
        attributes: (0, $4jqJv.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dialog-content-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1xDo.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c53bf002280dbd18$var$DialogContentLazy, props)));

});
parcelRegister("34Vv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $827c4d80e4d41b48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $pa9q9.flagService)
        });
};
var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;

});

parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

const $e6fca9f53887b39e$export$dc83269c840e42 = 'jiraUpFlowTouchpoint';

parcelRegister("4jqJv", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytic", () => $16744891cea79871$export$e4e69593f7c9f3b7);
$parcel$export(module.exports, "jiraUpFlowTouchpointUpgradePlanInteraction", () => $16744891cea79871$export$e2228116fc254cca);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $16744891cea79871$export$94ee0b5fca1e74d2);

var $dGrdR = parcelRequire("dGrdR");

var $jcw0u = parcelRequire("jcw0u");

var $bCf8q = parcelRequire("bCf8q");

const $16744891cea79871$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $jcw0u.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $e6fca9f53887b39e$export$dc83269c840e42),
            packageName: (0, $e6fca9f53887b39e$export$dc83269c840e42),
            teamName: 'luna-growth'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $16744891cea79871$export$e2228116fc254cca = (0, $dGrdR.metrics).interaction({
    key: `${(0, $e6fca9f53887b39e$export$dc83269c840e42)}.upgrade.plan`
});
const $16744891cea79871$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });

});

parcelRegister("g1xDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcae5497552c111c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iwwXK = parcelRequire("iwwXK");
const $dcae5497552c111c$var$DialogContentFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcae5497552c111c$var$FallbackWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "100%",
        testId: "up-flow-touchpoint.ui.dialog-content.fallback.full-width"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "62.5%",
        testId: "up-flow-touchpoint.ui.dialog-content.fallback.medium-width"
    }));
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$dcae5497552c111c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($dcae5497552c111c$var$DialogContentFallback);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dcae5497552c111c$var$FallbackWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1yk2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4fVfu", function(module, exports) {

let $3194f88d05c4aec5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3194f88d05c4aec5$var$load("h2MrD"),
    $3194f88d05c4aec5$var$load("bYT2S"),
    $3194f88d05c4aec5$var$load("hPzOn"),
    $3194f88d05c4aec5$var$load("eNmuD"),
    $3194f88d05c4aec5$var$load("198cs")
]).then(()=>parcelRequire('l7IUB'));

});





$parcel$global.rwr("dzRix", () => { parcelRequire("faPQm");
 }, ["eNmuD","dsiAd","hPzOn","2Lfdl","kfXhT","4ogRW","9vNc4","i5RRW","92sUi","kWrFZ","fr9NE","cM9em","bYT2S","h2MrD","3PrnJ"]);
$parcel$global.rlb("dzRix")
//# sourceMappingURL=async-upflow.19ddd0f6.js.map
